export default __webpack_public_path__ + "static/media/icontos.e11c8562.png";